export const AssetPopularDestinationsBase = {
  FLIGHTS: [
    'MDE', 'CTG', 'SMR', 'BOG', 'MIA', 'MAD'
  ],
  HOTELS: [
    'CTG', 'SMR', 'MDE', 'PUJ', 'CUN', 'MIA'
  ],
  AUTOS: [
    'BOG', 'MIA', 'MDE', 'CTG', 'BAQ', 'SMR'
  ],
  BUSES: [
    'CTG', 'ADZ', 'SMR', 'MDE', 'CUN', 'BOG'
  ],
  PACKAGES: [
    'ADZ', 'CTG', 'SMR', 'PUJ', 'CUN', 'PTY'
  ],
  BYHOURS: [
    'BOG', 'MEX', 'LIM', 'MDE', 'PTY', 'BAQ'
  ],
  TOUR_AND_ACTIVITIES: [
    'MDE', 'CTG', 'BOG', 'SMR', 'PEI', 'ADZ'
  ],
  BASE_IMAGE: 'https://images.rappi.com/web/travel/destinations/dest-{code}.jpg'
};
